import { Component } from '@angular/core';

@Component({
  templateUrl: './invalid-platform.component.html'
})
export class InvalidPlatformComponent {

  constructor() {
  }

  getDbIdentityFromUrl(): string {
    const currentAddress: string = window.location.href;
    const dbIdentity = currentAddress.split('.')[0];
    return dbIdentity.replace('http://', '').replace('https://', '');
  }
}
